<template>
    <div>
        <div class="form-popup-header">
            <div class="form-popup-title" v-text="formName" />
            <PreLoginLanguageSelector :availableLanguages="form.languages" />
        </div>
        <div class="form-popup-content">
            <ContractFormRender
                @enter="submit"
                ref="form"
                :form="form"
                :selectedLanguage="this.selectedLanguage"
            />
        </div>
        <div class="form-popup-footer">
            <!-- <img :src="$env.getAppLogo().logo" /> -->
            <ActionButton
                @click="submit"
                materialIcon="send"
                label="BUTTON_SEND"
            />
        </div>
    </div>
</template>
<script>
import PreLoginLanguageSelector from '@/views/PreLoginView/PreLoginLanguageSelector.vue'

export default {
    components: {
        ContractFormRender: () => import('./ContractFormRender.vue'),
        PreLoginLanguageSelector
    },
    props: {
        form: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            parentInput: []
        }
    },
    computed: {
        formName() {
            return this.form.names[this.selectedLanguage] || this.form.name
        },
        selectedLanguage() {
            return this.$i18n.locale
        }
    },
    methods: {
        validatePeselFields(data) {
            const types = [
                'pesel',
                'parent_1_pesel',
                'parent_2_pesel',
                'pickuper_1_pesel',
                'pickuper_2_pesel',
                'pickuper_3_pesel'
            ]
            return types.every(type => {
                const field = data.find(field => field.type == type)
                if (!field || (!field.required && field.input == ''))
                    return true
                const pesel = field.input
                return pesel.match(/^\d{11}$/)
            })
        },
        submit() {
            const formData = this.$refs.form.getFormData()
            if (!this.validatePeselFields(formData))
                return this.$Notif.error('ERROR_FIELD_PESEL')
            if (formData) {
                this.$emit('formFilled', formData)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.form-popup-header {
    display: flex;
    justify-content: space-between;
}
.form-popup-title {
    font-size: 1.6rem;
    font-family: $input-family;
    color: $input;
}
.form-popup-content {
    margin-top: 1rem;
    padding-bottom: 1rem;
}
.form-popup-footer {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    img {
        height: 3rem;
    }
}
</style>
